import VueLazyLoad from 'vue3-lazyload';

export function useLazyLoad() {
    return VueLazyLoad;
}
